/**
 * Library
 */
import { createReducer, Reducer } from '@reduxjs/toolkit';

import { libraryInit } from 'redux/reducers/init';

/**
 * Actions
 */
import {
  downloadLibrary,
  downloadLibraryFailure,
  downloadLibrarySuccess,
  insertLibrary,
  insertLibraryFailure,
  insertLibrarySuccess,
  requestLibraryCount,
  requestLibraryCountFailure,
  requestLibraryCountSuccess,
  requestLibraryList,
  requestLibraryListFailure,
  requestLibraryListSuccess,
} from 'redux/actions/library/actions';
import {
  requestMediaconvertJobListSuccess,
  requestMediaconvertJobListFailure,
} from 'redux/actions/library/actions';

/**
 * Reducers
 */
const library = createReducer(libraryInit, {
  [requestLibraryList.type]: (state, action: RequestLibraryListAction) => {
    state.isLoading = true;
  },
  [requestLibraryListSuccess.type]: (state, action: RequestLibraryListSuccessAction) => {
    const { libraryList, pagination } = action.payload;
    state.isLoading = false;
    state.libraryList = libraryList;
    state.pagination = pagination;
  },
  [requestLibraryListFailure.type]: (state, action: RequestLibraryListFailureAction) => {
    state.isLoading = false;
    state.libraryList = [];
  },
  [requestMediaconvertJobListSuccess.type]: (
    state,
    action: RequestMediaconvertJobListSuccessAction,
  ) => {
    const { libraryList, pagination } = action.payload;
    state.isLoading = false;
    state.jobList = libraryList;
    state.pagination = pagination;
  },
  [requestMediaconvertJobListFailure.type]: (
    state,
    action: RequestMediaconvertJobListFailureAction,
  ) => {
    state.isLoading = false;
    state.jobList = [];
  },
  [requestLibraryCount.type]: (state, action) => {
    state.isLoading = true;
  },
  [requestLibraryCountSuccess.type]: (state, action) => {
    const { count } = action.payload;
    state.isLoading = false;
    state.libraryCount = count;
  },
  [requestLibraryCountFailure.type]: (state, action) => {
    state.isLoading = false;
    state.libraryCount = -1;
  },
  [insertLibrary.type]: (state, action) => {
    state.isLoadingInsert = true;
  },
  [insertLibrarySuccess.type]: (state, action) => {
    state.isLoadingInsert = false;
  },
  [insertLibraryFailure.type]: (state, action) => {
    state.isLoadingInsert = false;
  },
  [downloadLibrary.type]: (state, action) => {},
  [downloadLibrarySuccess.type]: (state, action) => {},
  [downloadLibraryFailure.type]: (state, action) => {},
});

export default library;
